// storage.service.ts

import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LOCAL_STORAGE } from '../constants/context-token';

@Injectable()
export class StorageService {
  private isBrowser = false;
  private storage = inject(LOCAL_STORAGE);
  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // Save data to sessionStorage
  saveData<T>(key: string, data: T): void {
    if (this.isBrowser) {
      this.storage.setItem(key, JSON.stringify(data));
    }
  }

  // Get data from sessionStorage
  getItem<T>(key: string): T | null {
    const storedValue = this.storage.getItem(key);
    return storedValue ? (JSON.parse(storedValue) as T) : null;
  }

  // Remove data from sessionStorage
  removeData(key: string): void {
    if (this.isBrowser) {
      this.storage.removeItem(key);
    }
  }

  // Clear all data from sessionStorage
  // clearAllData(): void {
  //   if(this.isBrowser){
  //     this.storage.clear();
  //   }
  //}
}
